export default __webpack_public_path__ + "static/media/Cancel.f1a218ba.svg";